import { Table } from 'antd';
import i18next from 'i18next';
import { useTranslation } from "react-i18next";
import { useContext, useEffect } from "react";
import { getColumns, redirect } from './config';
import { LinkingContext } from '../../../context/Linking';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { DocumentsService, EventsService, LirService, SCLService, StakeholderService } from '../../../services';

export default function LinkingTemplate({ conf, namespace }) {
  const { t } = useTranslation();
  const { data, addData } = useContext(LinkingContext);

  const columns = getColumns({
    t,
    redirect,
    mod: conf.mod,
    language: i18next.language,
    mode: conf.mode,
  });
  const id = conf.allData.datastakeId;

  const dataSource = data[id];
  const source = conf.allData.authorId;

  const changeData = async () => {
    try {
      switch (namespace) {
        case 'stakeholder':
        case 'scp':
          const scpData = await StakeholderService.getLinking({ stakeholderId: id, source })
          addData(id, scpData.data);
          break;
        case 'scl':
        case 'village':
        case 'location':
          const sclRes = await SCLService.getLinking({ sclId: id, source })
          addData(id, sclRes.data);
          break;
        case 'document':
          const documentRes = await DocumentsService.getLinking({ documentId: id, source })
          addData(id, documentRes.data);
          break;
        case 'event':
        case 'incidents':
        case 'testimonials':
        case 'corrective-actions':
          const eventsRes = await EventsService.getLinking({ eventId: id, source })
          addData(id, eventsRes.data);
          break;
        case 'lir':
          const lirRes = await LirService.getLinking({ lirId: id, source });
          addData(id, lirRes.data);
          break;
        default:
          return;
      }
    }
    catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!dataSource) {
      changeData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={formatClassname([
        'content',
        'documents-layout',
      ])}
      style={{}}
    >
      <div className="content-card">
        <div className="wrapper" style={{ flexDirection: 'column' }}>
          <div className="view-header">
            <h1>
              {t('Linked Subjects')}
            </h1>
          </div>
          <div style={{ flexDirection: 'column', paddingTop: 0 }}>
            <Table
              columns={columns}
              dataSource={dataSource || []}
              loading={!dataSource}
              pagination={{
                pageSize: 20,
              }}
              size="small"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
